var _circle, _circle2, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCompleteStar = function SvgCompleteStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#F3C820"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 10,
    fill: "#E8BA0D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#complete_star_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15.754 19.165 2.305 1.395a.554.554 0 0 0 .828-.6l-.61-2.623 2.038-1.766a.554.554 0 0 0-.317-.972l-2.683-.228-1.05-2.478a.556.556 0 0 0-1.022 0l-1.05 2.472-2.684.228a.554.554 0 0 0-.316.972l2.039 1.767-.611 2.622a.554.554 0 0 0 .827.6l2.306-1.389Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "complete_star_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(11 11)",
    d: "M0 0h10v10H0z"
  })))));
};

export { SvgCompleteStar as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTYiIGN5PSIxNiIgcj0iMTYiIGZpbGw9IiNGM0M4MjAiLz4KPGNpcmNsZSBjeD0iMTYiIGN5PSIxNiIgcj0iMTAiIGZpbGw9IiNFOEJBMEQiLz4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzY2OF8yMDY1NCkiPgo8cGF0aCBkPSJNMTUuNzUzOSAxOS4xNjUzTDE4LjA1OTQgMjAuNTU5N0MxOC40ODE2IDIwLjgxNTMgMTguOTk4MyAyMC40Mzc1IDE4Ljg4NzIgMTkuOTU5N0wxOC4yNzYxIDE3LjMzNzVMMjAuMzE1IDE1LjU3MDhDMjAuNjg3MiAxNS4yNDg2IDIwLjQ4NzIgMTQuNjM3NSAxOS45OTgzIDE0LjU5ODZMMTcuMzE1IDE0LjM3MDhMMTYuMjY1IDExLjg5MzFDMTYuMDc2MSAxMS40NDMxIDE1LjQzMTYgMTEuNDQzMSAxNS4yNDI4IDExLjg5MzFMMTQuMTkyOCAxNC4zNjUzTDExLjUwOTQgMTQuNTkzMUMxMS4wMjA1IDE0LjYzMTkgMTAuODIwNSAxNS4yNDMxIDExLjE5MjggMTUuNTY1M0wxMy4yMzE2IDE3LjMzMTlMMTIuNjIwNSAxOS45NTQyQzEyLjUwOTQgMjAuNDMxOSAxMy4wMjYxIDIwLjgwOTcgMTMuNDQ4MyAyMC41NTQyTDE1Ljc1MzkgMTkuMTY1M1oiIGZpbGw9IndoaXRlIi8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfNjY4XzIwNjU0Ij4KPHJlY3Qgd2lkdGg9IjEwIiBoZWlnaHQ9IjEwIiBmaWxsPSJ3aGl0ZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTEgMTEpIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==";